import { request } from "@/interface/helper";

const str = "settingIP";

export const settingIP = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/ip/list" }),
    add: (data) => request({ data, method: "post", url: "/ip/add" }),
    detail: (data) => request({ data, method: "post", url: "/ip/del" }),
  },
};
